module.exports = __webpack_public_path__ + "img/group.8806a281.png";